import { http } from '@pendo/http';

export function fetchUserJourneyTasks () {
    return http.get('/api/s/_SID_/userjourneytask');
}